import { get } from 'lodash';
export class CoverageForm {
  monthlyBenefit: number | undefined;
  plan: string | undefined;
  planPremiumMode: string | undefined;
  premiumTerm: string | undefined;
  premiumTermYears: number | undefined;
  escBenefit: string | undefined;
  promoCode: string | undefined;
  promoNric: string | undefined;

  constructor(initial: any) {
    this.monthlyBenefit = get(initial, 'monthlyBenefit', undefined);
    this.plan = get(initial, 'plan', undefined);
    this.planPremiumMode = get(initial, 'planPremiumMode', 'AP');
    this.premiumTerm = get(initial, 'premiumTerm', undefined);
    this.premiumTermYears = get(initial, 'premiumTermYears', undefined);
    this.escBenefit = get(initial, 'escBenefit', undefined);
    this.promoCode = get(initial, 'promoCode', '');
    this.promoNric = get(initial, 'promoNric', '');
  }
}